var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBlackPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10C20.5 15.5228 16.0228 20 10.5 20C4.97715 20 0.5 15.5228 0.5 10C0.5 4.47715 4.97715 0 10.5 0C16.0228 0 20.5 4.47715 20.5 10ZM8.3125 6.25C7.44955 6.25 6.75 6.94955 6.75 7.8125V12.1875C6.75 13.0504 7.44955 13.75 8.3125 13.75C9.17544 13.75 9.875 13.0504 9.875 12.1875V7.8125C9.875 6.94955 9.17544 6.25 8.3125 6.25ZM12.6875 6.25C11.8246 6.25 11.125 6.94955 11.125 7.8125V12.1875C11.125 13.0504 11.8246 13.75 12.6875 13.75C13.5504 13.75 14.25 13.0504 14.25 12.1875V7.8125C14.25 6.94955 13.5504 6.25 12.6875 6.25Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBlackPause);
export default __webpack_public_path__ + "static/media/ico-black-pause.74adb3aa123de8ac8c37fe4531388d89.svg";
export { ForwardRef as ReactComponent };